import React from 'react';
import {Image} from "react-bootstrap";

const AboutPage = () => {
    return (
        <div className="container">
            <section className="about py-5">
                <div className="container">
                    <h2 className="text-center mb-4">About Quippy</h2>
                    <p className="lead text-center">I started working on Quippy to demonstrate what you can do with
                        tools like ChatGPT and Co-pilot. I am using these tools to build the project. I used them for
                        inspiration for the name, for building the site, for writing the CDK code, creating the
                        visuals.</p>
                </div>
                <div className="container">
                    <div className="alert alert-warning text-center">
                        <p>Beware, the interactive part is now only for me, you have to login using my AWS account. I do
                            not want people to abuse quippy, at least, not yet.</p>
                    </div>
                </div>
                <div className="container py-5">
                    <h2 className="text-center mb-4">Our Team</h2>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="team-member text-center">
                                <Image src="/images/quippy-headshot.png" alt="Quippy" roundedCircle
                                       style={{width: '200px', height: '200px'}}/>
                                <h3>Quippy</h3>
                                <p>Best assistant there is (for me)</p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="team-member text-center">
                                <Image src="/images/jettro.jpg" alt="Jettro" roundedCircle
                                       style={{width: '200px', height: '200px'}}/>
                                <h3>Jettro Coenradie</h3>
                                <p>Software Engineer for the project</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container py-5">
                    <h2 className="text-center mb-4">Technologies used</h2>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                            <strong>TypeScript:</strong> A strongly typed programming language that builds on
                            JavaScript.
                            <a href="https://www.typescriptlang.org">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>Python:</strong> A high-level, interpreted programming language.
                            <a href="https://www.python.org">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>JavaScript:</strong> A programming language that conforms to the ECMAScript
                            specification.
                            <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>npm:</strong> A package manager for the JavaScript programming language.
                            <a href="https://www.npmjs.com">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>React:</strong> A JavaScript library for building user interfaces.
                            <a href="https://reactjs.org">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>AWS CDK:</strong> A framework for defining cloud infrastructure in code.
                            <a href="https://aws.amazon.com/cdk">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>AWS Lambda:</strong> A serverless compute service that runs your code in
                            response to events.
                            <a href="https://aws.amazon.com/lambda">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>AWS API Gateway:</strong> A fully managed service that makes it easy for
                            developers to create, publish, maintain, monitor, and secure APIs.
                            <a href="https://aws.amazon.com/api-gateway">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>Bootstrap:</strong> A popular CSS framework for developing responsive and
                            mobile-first websites.
                            <a href="https://getbootstrap.com">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>Amazon Cognito:</strong> A service that provides authentication, authorization, and
                            user management for web and mobile apps.
                            <a href="https://aws.amazon.com/cognito">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>AWS Amplify:</strong> A set of tools and services for building scalable full-stack
                            applications.
                            <a href="https://aws.amazon.com/amplify">Learn more</a>
                        </li>
                        <li className="list-group-item">
                            <strong>Amazon Bedrock:</strong> A service that makes it easy to build and scale generative
                            AI applications.
                            <a href="https://aws.amazon.com/bedrock">Learn more</a>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default AboutPage;